module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/female_genitalia-e0ea712a19389164f6768a930f952249.png";